import { CompositeDecorator } from 'draft-js';
import { List } from 'immutable';

export const styles = {
  claimEditors: {
    display: 'flex',
    flexFlow: 'column',
    overflow: 'auto',
    fontFamily: 'Roboto, Helvetical, Arial, sans-serif',
    fontSize: '14pt',
    margin: '0.2em',
    width: '60vw',
    height: '90vh'
    //border: '2px solid blue',
  },
  claimEditor: {
    width: '98%',
    border: '1px solid blue',
    borderRadius: '0.3em',
    cursor: 'text',
    margin: '0.2em',
    backgroundColor: 'whitesmoke',
    boxShadow: '2px 2px 2px gray',
  },
  claimEditorHidden: {
    width: '98%',
    height: '0.2em',
    borderBottom: '1px solid blue',
    margin: '0.3em',
    borderRadius: '0.3em',
    backgroundColor: 'whitesmoke',
    boxShadow: '2px 2px 2px gray',
  },
  claimEditorHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: '0.2em 0.4em',
  },
  claimEditorFooter: {
    fontSize: '0.9em',
    padding: '0.2em 0.4em',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline'
  },
  editor: {
    minHeight: '3.0em',
    backgroundColor: 'white',
    fontSize: '1.0em',
    lineHeight: '1.5em',
  },
  depWiEditor: {
    backgroundColor: 'white',
    fontSize: '1.0em',
    lineHeight: '1.5em',
  },
  tabsContainer: {
    display: 'flex', flexFlow: 'column',
    height: '90vh',
    width: '38vw',
    overflow: 'auto',
    fontSize: '1.0em'
  },
  button: {
    margin: '0.2em',
    textAlign: 'center',
  },
  immutable: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    padding: '2px 0',
  },
  mutable: {
    backgroundColor: 'PaleTurquoise',//'rgba(204, 204, 255, 1.0)',
    padding: '2px 0',
  },
  segmented: {
    backgroundColor: 'rgba(248, 222, 126, 1.0)',
    padding: '2px 0',
  },
  newEntity: { color: 'red', },
  writtenDescription: { color: 'blue', },
  writtenDescriptionError: { color: 'red', },
  box: { margin: '0.2em', border: '1px solid black' },
};

export const findWithRegex = (regex, contentBlock, callback) => {
  const text = contentBlock.getText();
  let start, end;
  const matches = text.matchAll(regex);
  //console.log('finding in regex', regex, text);
  for (const match of matches) {
    start = match.index;
    end = start + match[0].length;
    //console.log('Matched', match, start, end);
    callback(start, end, contentBlock);
  }
};

function listEntities(block, editorContent) {
  block.findEntityRanges(
    (c) => {
      const ek = c ? c.getEntity() : null;
      return ek !== null && editorContent.getEntity(ek).getType() === 'TOKEN';
    },
    (start, end) => { console.log('Found', start, end); }
  );
}

function getEntityStrategy(mutability) {
  return function(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        if (entityKey === null) {
          return false;
        }
        return contentState.getEntity(entityKey).getMutability() === mutability;
      },
      callback
    );
  };
}

function entityStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      if (entityKey === null) {
        return false;
      }
      return contentState.getEntity(entityKey).getMutability() === 'MUTABLE';
    },
    callback
  );
}

// Looks for @ ... @ for creating inline entities
function newEntityStrategy(contentBlock, callback, contentState) {
  const regex = /@[^@"]+@?/gi;
  findWithRegex(regex, contentBlock, callback);
}

// Looks for completed written description strings " ... "
// They must terminate at the end of a line to be syntatically correct
function WDStrategy(contentBlock, callback, contentState) {
  const regex = /"[^"]+"$/gi;
  findWithRegex(regex, contentBlock, callback);
}

// Looks for written description strings " ... "
function WDErrorStrategy(contentBlock, callback, contentState) {
  const regex = /"[^"]+"?/gi;
  findWithRegex(regex, contentBlock, callback);
}

// highlight entities as you go
/*
function commentStrategy2(contentBlock, callback, contentState) {
  const text = contentBlock.getText();
  const words = text.split(/ +/);
  const lastWord = words[words.length - 1];
  const start = text.indexOf(lastWord);
  const matches = [];
  const entities = cseModel.entityMap;
  for (const item of Object.entries(entities)) {
    if (item[1].text.startsWith(lastWord))
      callback(start, start + lastWord.length);
    let index = text.indexOf(item[1].text);
    if (index != -1) {
      console.log(index, item[1].text, item[1].text.length);
      callback(index, index + item[1].text.length);
    }
  }
}
*/

function getDecoratedStyle(mutability) {
  switch (mutability) {
  case 'IMMUTABLE': return styles.immutable;
  case 'MUTABLE': return styles.mutable;
  case 'SEGMENTED': return styles.segmented;
  default: return null;
  }
}

const TokenSpan = (props) => {
  const style = getDecoratedStyle(
    props.contentState.getEntity(props.entityKey).getMutability()
  );
  return (
    <span data-offset-key={props.offsetkey} style={style}>
            {props.children}
    </span>
  );
};

const NewEntitySpan = (props) => {
  //console.log('MAKING NEW ELM', props.children);
  return (
    <span data-offset-key={props.offsetkey} style={styles.newEntity}>{props.children}</span>
  );
};


const WDSpan = (props) => {
  return (
    <span data-offset-key={props.offsetkey}
          style={styles.writtenDescription}>
      {props.children}
    </span>
  );
};

const WDErrorSpan = (props) => {
  //console.log('MAKING WD', props.children);
  return (
    <span data-offset-key={props.offsetkey} style={styles.writtenDescriptionError}>{props.children}</span>
  );
};

// ---------------------------------------------------------------------

const Span = (props) => <span>{props.children}</span>;

class CompoundDecorator {
  constructor(decorators = []) {
    this.decorators = decorators.map((decorator) => {
      return decorator.strategy && decorator.component ?
        new CompositeDecorator([decorator]) :
        decorator;
    });
  }

  getDecorations(block, contentState) {
    const emptyTuples = Array(block.getText().length).fill(
      Array(this.decorators.length).fill(null)
    );

    const decorations = this.decorators.reduce((tuples, decorator, index) => {
      const blockDecorations = decorator.getDecorations(block, contentState);

      return tuples.map((tuple, tupleIndex) => {
        return [
          ...tuple.slice(0, index),
          blockDecorations.get(tupleIndex),
          ...tuple.slice(index + 1),
        ];
      });
    }, emptyTuples);

    return List(decorations.map(JSON.stringify));
  }

  getComponentForKey(key) {
    const tuple = JSON.parse(key);
    return (props) => {
      const { decoratorProps, ...compositionProps } = props;
      const Composed = tuple.reduce((Composition, decoration, index) => {
        if (decoration !== null) {
          const decorator = this.decorators[index];
          const Component = decorator.getComponentForKey(decoration);
          const componentProps = {
            ...compositionProps,
            ...decoratorProps[index],
          };
          return () => (
            <Component {...componentProps}>
              <Composition {...compositionProps} />
            </Component>
          );
        }
        return Composition;
      }, Span);
      return (
        <Composed>{props.children}</Composed>
      );
    };
  }

  getPropsForKey(key) {
    const tuple = JSON.parse(key);
    return {
      decoratorProps: tuple.map((decoration, index) => {
        const decorator = this.decorators[index];
        return decoration !== null ? decorator.getPropsForKey(decoration) : {};
      }),
    };
  }
}

export const decoratorArray = [
  {
    strategy: WDStrategy,
    component: WDSpan,
  },
  {
    strategy: WDErrorStrategy,
    component: WDErrorSpan,
  },
  {
    strategy: newEntityStrategy,
    component: NewEntitySpan,
  },
  {
    strategy: entityStrategy,
    component: TokenSpan,
  },
  //new CompositeDecorator([{strategy: entityStrategy, component: TokenSpan}]),
  //{
  //  strategy: getEntityStrategy('MUTABLE'),
  //  component: TokenSpan,
  ///},
];

//https://jsfiddle.net/paulyoung85/2unzgt68/
export const decorator = new CompoundDecorator(decoratorArray);

// Unused code here....

// function findTokenEntities(contentBlock, callback, contentState) {
//   contentBlock.findEntityRanges(
//     (character) => {
//       const entityKey = character.getEntity();
//       return (
//         entityKey !== null &&
//         contentState.getEntity(entityKey).getType() === 'TOKEN'
//       );
//     },
//     callback
//   );
// }

// const Token = (props) => {
//   const {name} = props.contentState.getEntity(props.entityKey).getData();
//   return (
//     <span style={{color: 'red'}}>
//       {name}
//     </span>
//   );
// };

// const getEntities = (editorState, entityType = null) => {
//     const content = editorState.getCurrentContent();
//     const entities = [];
//     content.getBlocksAsArray().forEach((block) => {
//         let selectedEntity = null;
//         block.findEntityRanges(
//             (character) => {
//                 if (character.getEntity() !== null) {
//                     const entity = content.getEntity(character.getEntity());
//                     if (!entityType || (entityType && entity.getType() === entityType)) {
//                         selectedEntity = {
//                             entityKey: character.getEntity(),
//                             blockKey: block.getKey(),
//                             entity: content.getEntity(character.getEntity()),
//                         };
//                         return true;
//                     }
//                 }
//                 return false;
//             },
//             (start, end) => {
//                 entities.push({...selectedEntity, start, end});
//             });
//     });
//     return entities;
// };

